// Both admins show patient records, so nothing an admin does there may reach
// PostHog: no events, no pageviews, no session recording, no network capture.
const adminPaths = ["/admin", "/dashboard/admin"];

export const isAdminAddress = (pathname: string): boolean =>
  adminPaths.some((adminPath) => pathname === adminPath || pathname.startsWith(`${adminPath}/`));
